module.exports = __webpack_public_path__ + "static/media/14-1.fc3e1d7f.mp3";